import { Action, Reducer } from "redux";
import { VisualIdentityState, VisualIdentityTypes, VisualIdentityActionTypes } from "./visualIdentityTypes";
import { isNullUndefined } from "@/main/services/utils";
import colors from "@/main/style/colors";

export const INITIAL_STATE: VisualIdentityState = {
	visualIdentity: {
		colors: colors,
		logoUrl: undefined,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const visualIdentityReducer: Reducer<VisualIdentityState> = (
	state: VisualIdentityState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as VisualIdentityActionTypes;
	switch (actionTypes.type) {
		case VisualIdentityTypes.GET_VISUAL_IDENTITY:
			return {
				...state,
				visualIdentity: { ...state.visualIdentity, isLoading: true },
			};
		case VisualIdentityTypes.SAVE_VISUAL_IDENTITY:
			return {
				...state,
				visualIdentity: {
					...state.visualIdentity,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					colors: actionTypes.payload.colors,
					logoUrl: actionTypes.payload.logoUrl,
				},
			};
		case VisualIdentityTypes.UPDATE_COLORS:
			return {
				...state,
				visualIdentity: {
					...state.visualIdentity,
					colors: actionTypes.payload.colors,
				},
			};
		case VisualIdentityTypes.UPDATE_LOGO_URL:
			return {
				...state,
				visualIdentity: {
					...state.visualIdentity,
					logoUrl: actionTypes.payload.logoUrl,
				},
			};
		case VisualIdentityTypes.SET_VISUAL_IDENTITY: {
			const newState = { ...state.visualIdentity };

			if (!isNullUndefined(actionTypes.payload.primaryColor) && newState.colors) {
				newState.colors = {
					...newState.colors,
					pantone2726C: actionTypes.payload.primaryColor,
				};
			}

			if (!isNullUndefined(actionTypes.payload.headerColor) && newState.colors) {
				newState.colors = {
					...newState.colors,
					headerColor: actionTypes.payload.headerColor,
				};
			}

			if (!isNullUndefined(actionTypes.payload.logoUrl)) {
				newState.logoUrl = actionTypes.payload.logoUrl;
			}

			return {
				...state,
				visualIdentity: newState,
			};
		}
		case VisualIdentityTypes.RESET_COLORS:
			return {
				...state,
				visualIdentity: {
					...state.visualIdentity,
					colors: null,
					logoUrl: "",
				},
			};
		case VisualIdentityTypes.RESET_REDUCER_VISUAL_IDENTITY:
			return INITIAL_STATE;
		default:
			return state;
	}
};

export default visualIdentityReducer;
